import "./App.css";
import "./fonts.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Mainroute from "./routes/Mainroute";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const queryClient = new QueryClient();
  const token = localStorage.getItem("logintoken");
  // const payload = token ? JSON.parse(atob(token.split(".")[1])) : null;
  // const expiry = payload ? new Date(payload.expiry * 1000) : null;
 
  const [hide ,setHide]=useState(false)
  return (
    <div className="App no-select">
      <QueryClientProvider client={queryClient}>
      {/* {token && token.length > 0 ? (
        <>
          {" "}
          <Sidebar />
           
        </>
      ) : (
        <LoginRout />
      )} */}
      
      <Mainroute/>
       <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnHover={false}
      />
      </QueryClientProvider>
    </div>
  );
}

export default App;
